var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-2 0 24 20",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface2672668"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(12.941176%,58.823529%,95.294118%)",
      fillOpacity: 1
    },
    d: "M 19.207031 2.417969 L 10.542969 2.417969 L 10.542969 17.582031 L 19.207031 17.582031 C 19.507812 17.582031 19.75 17.339844 19.75 17.042969 L 19.75 2.957031 C 19.75 2.660156 19.507812 2.417969 19.207031 2.417969 Z M 19.207031 2.417969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.542969 5.125 L 18.125 5.125 L 18.125 6.207031 L 10.542969 6.207031 Z M 10.542969 7.292969 L 18.125 7.292969 L 18.125 8.375 L 10.542969 8.375 Z M 10.542969 9.457031 L 18.125 9.457031 L 18.125 10.542969 L 10.542969 10.542969 Z M 10.542969 11.625 L 18.125 11.625 L 18.125 12.707031 L 10.542969 12.707031 Z M 10.542969 13.792969 L 18.125 13.792969 L 18.125 14.875 L 10.542969 14.875 Z M 10.542969 13.792969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(5.098039%,27.843137%,63.137255%)",
      fillOpacity: 1
    },
    d: "M 11.625 19.75 L 0.25 17.582031 L 0.25 2.417969 L 11.625 0.25 Z M 11.625 19.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.464844 13.796875 L 6.992188 13.796875 L 6.019531 8.929688 C 5.964844 8.671875 5.933594 8.390625 5.921875 8.074219 L 5.90625 8.074219 C 5.882812 8.421875 5.847656 8.707031 5.800781 8.929688 L 4.796875 13.796875 L 3.265625 13.796875 L 1.71875 6.207031 L 3.164062 6.207031 L 3.996094 11.261719 C 4.03125 11.480469 4.058594 11.769531 4.074219 12.128906 L 4.097656 12.128906 C 4.109375 11.859375 4.152344 11.5625 4.21875 11.238281 L 5.285156 6.207031 L 6.707031 6.207031 L 7.671875 11.300781 C 7.707031 11.488281 7.738281 11.757812 7.765625 12.117188 L 7.78125 12.117188 C 7.792969 11.839844 7.820312 11.558594 7.867188 11.273438 L 8.683594 6.207031 L 10.019531 6.207031 Z M 8.464844 13.796875 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.6afb69b0.svg";
export { ForwardRef as ReactComponent };